import React, {useState} from 'react';
import styles from "./Tabs.module.scss"
import Button from "../Button/Button";

interface Tab {
    label: string;
}

interface TabsProps {
    tabs: Tab[];
    children: React.ReactNode;
}

const Tabs: React.FC<TabsProps> = ({tabs, children}) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleTabClick = (index: number) => {
        setActiveIndex(index);
    };

    return (
        <>
            <ul className={styles.tabList}>
                {tabs.map((tab, index) => (
                    <li key={index} className={styles.tabListItem}>
                        <Button isActive={activeIndex === index}
                                classButton="tabButton"
                                onClick={() => handleTabClick(index)}
                        >
                            {tab.label}
                        </Button>
                    </li>
                ))}
            </ul>
            <div className="tab-content">
                {React.Children.toArray(children)[activeIndex]}
            </div>
        </>
    );
};

export default Tabs;
